// These must be the first lines in src/index.js
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { install } from '@material-ui/styles';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { clearExpiredAuthStorage } from './utils/authStorage';

// Clear expired Auth0 cache before Auth0Provider so we don't send expired tokens
clearExpiredAuthStorage();

install();

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
